'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTime(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2c3.321 0 6 2.679 6 6s-2.679 6-6 6a5.99 5.99 0 01-6-6c0-3.321 2.679-6 6-6zm-.221 1.714a.636.636 0 00-.636.636v3.085l.179.215 1.45 1.57a.622.622 0 00.88.034l.034-.034a.729.729 0 000-.99L8.414 6.854V4.35a.636.636 0 00-.635-.636z", fill: "currentColor" }))));
}

module.exports = SvgTime;
//# sourceMappingURL=Time.js.map
